import { faCalendarDays, faChartLine, faFile, faHouse, faHouseChimneyMedical, faSmile, faSterlingSign } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NavLink } from 'react-router-dom'
import { useEffect, useState } from 'react'

import useAuth from '../../hooks/useAuth'


const navClasses =
  'w-full text-white py-3 px-3 flex relative rounded-md items-center'

function Nav() {
  const { can, auth } = useAuth()

  const [isOHPractitioner, setIsOHPractitioner] = useState(false)

  const userServices = auth?.user?.services.map((service) => service.title) || []

  useEffect(() => {
    if (userServices.includes('Occupational Health Assessment') || userServices.includes('Occupational Health Practitioner') || userServices.includes('PPQ Follow Up')) {
      setIsOHPractitioner(true)
    } else {
      setIsOHPractitioner(false)
    }
  }, [auth])

  return (
    <ul>
      {can('access dashboard') ? (
        <li className="mb-2">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? 'bg-blue-500 ' + navClasses
                : navClasses + ' hover:bg-slate-700'
            }
          >
            <span className="flex justify-start w-10">
              <FontAwesomeIcon icon={faHouse} className="mr-4 text-xl" />
            </span>
            Home
          </NavLink>
        </li>
      ) : null}

      {can('access calendar') ? (
        <li className="mb-2">
          <NavLink
            to="/calendar"
            className={({ isActive }) =>
              isActive
                ? 'bg-blue-500 ' + navClasses
                : navClasses + ' hover:bg-slate-700'
            }
          >
            <span className="flex justify-start w-10">
              <FontAwesomeIcon icon={faCalendarDays} className="mr-4 text-xl" />
            </span>
            Calendar
          </NavLink>
        </li>
      ) : null}

      {can('access their clinic') && !isOHPractitioner ? (
        <li className="mb-2">
          <NavLink
            to="/clinic"
            className={({ isActive }) =>
              isActive
                ? 'bg-blue-500 ' + navClasses
                : navClasses + ' hover:bg-slate-700'
            }
          >
            <span className="flex justify-start w-10">
              <FontAwesomeIcon
                icon={faHouseChimneyMedical}
                className="mr-4 text-xl"
              />
            </span>
            My Clinic
          </NavLink>
        </li>
      ) : null}

      {can('access their clients') && !isOHPractitioner ? (
        <li className="mb-2">
          <NavLink
            to="/clients"
            className={({ isActive }) =>
              isActive
                ? 'bg-blue-500 ' + navClasses
                : navClasses + ' hover:bg-slate-700'
            }
          >
            <span className="flex justify-start w-10">
              <FontAwesomeIcon icon={faSmile} className="mr-4 text-xl" />
            </span>
            My Clients
          </NavLink>
        </li>
      ) : null}

      {can('access their accounts') ? (
        <li className="mb-2">
          <NavLink
            to="/accounts"
            className={({ isActive }) =>
              isActive
                ? 'bg-blue-500 ' + navClasses
                : navClasses + ' hover:bg-slate-700'
            }
          >
            <span className="flex justify-start w-10">
              <FontAwesomeIcon icon={faSterlingSign} className="mr-4 text-xl" />
            </span>
            Accounts
          </NavLink>
        </li>
      ) : null}

      {can('access their reports') ? (
        <li className="mb-2">
          <NavLink
            to="/reports"
            className={({ isActive }) =>
              isActive
                ? 'bg-blue-500 ' + navClasses
                : navClasses + ' hover:bg-slate-700'
            }
          >
            <span className="flex justify-start w-10">
              <FontAwesomeIcon icon={faChartLine} className="mr-4 text-xl" />
            </span>
            Reports
          </NavLink>
        </li>
      ) : null}

      {can('access resources') && !isOHPractitioner ? (
        <li className="mb-2">
          <NavLink
            to="/resources"
            className={({ isActive }) =>
              isActive
                ? 'bg-blue-500 ' + navClasses
                : navClasses + ' hover:bg-slate-700'
            }
          >
            <span className="flex justify-start w-10">
              <FontAwesomeIcon icon={faFile} className="mr-4 text-xl" />
            </span>
            Resources
          </NavLink>
        </li>
      ) : null}
    </ul>
  )
}

export default Nav
